/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

/**
 * The root element that hosts CKEditor 5. It's being hidden while the Revision history plugin is activated.
 */
export const EDITOR_CONTAINER_IDENTIFIER = '#editor-container';

/**
 * The root element used to pass to `Editor.create()`.
 */
export const EDITOR_SOURCE_IDENTIFIER = '#editor';

/**
 * The element used to attach the toolbar when rendering Decoupled Editor.
 */
export const EDITOR_DECOUPLED_TOOLBAR_IDENTIFIER = '#editor-toolbar';

/**
 * The element used to attach the menu bar when rendering Decoupled Editor.
 */
export const EDITOR_DECOUPLED_MENU_BAR_IDENTIFIER = '#editor-menu-bar';

/**
 * The element passed to the editor configuration if the `DocumentOutline` plugin is enabled.
 */
export const EDITOR_OUTLINE_SIDEBAR_IDENTIFIER = '#editor-outline';

/**
 * The element passed to the editor configuration if `(RealTime)Comments` or `(RealTime)TrackChanges` plugins are enabled.
 */
export const EDITOR_ANNOTATIONS_SIDEBAR_IDENTIFIER = '#editor-annotations';

/**
 * The element passed to the editor configuration if the `PresenceList` plugin is enabled.
 */
export const EDITOR_PRESENCE_LIST_IDENTIFIER = '#editor-presence';

/**
 * The element passed to the editor configuration if the `Minimap` plugin is enabled.
 */
export const EDITOR_MINIMAP_SIDEBAR_IDENTIFIER = '#editor-minimap';

/**
 * The element used to attach the word count plugin.
 */
export const EDITOR_WORD_COUNT = '#editor-word-count';

/**
 * The elements passed to the editor configuration if the `RevisionHistory` plugin is enabled.
 *
 * * the entire container, to be shown after clicking the revision history button,
 * * the editable that presents a current revision (content),
 * * the sidebar that keeps stored revisions.
 */
export const EDITOR_REVISION_HISTORY_IDENTIFIER = '#editor-revision-history';
export const EDITOR_REVISION_HISTORY_EDITOR_IDENTIFIER = '#editor-revision-history-editor';
export const EDITOR_REVISION_HISTORY_SIDEBAR_IDENTIFIER = '#editor-revision-history-sidebar';

/**
 * The customer portal iframe element.
 */
export const CUSTOMER_PORTAL_USER_DATA_IFRAME_ID = 'customer-portal-user-data-iframe';
